import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfettiBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M46.0197 25.3613C46.7843 25.1916 47.5795 25.2179 48.3312 25.4374C49.0826 25.6569 49.7665 26.0622 50.3195 26.6161L93.3879 69.6855H93.3888L93.589 69.8993C94.0399 70.4114 94.3736 71.0173 94.5646 71.6747C94.783 72.4263 94.8081 73.2214 94.6379 73.9853C94.4676 74.749 94.1068 75.4573 93.59 76.0449C93.0734 76.6321 92.4172 77.0792 91.6818 77.3456L91.6828 77.3466L24.0051 101.959L24.006 101.96C23.1735 102.264 22.2709 102.324 21.4054 102.133C20.54 101.941 19.7471 101.507 19.1203 100.88C18.4935 100.253 18.0587 99.4601 17.8674 98.5947C17.6761 97.7292 17.7361 96.8266 18.0402 95.9941H18.0412L42.6535 28.3173C42.9202 27.5815 43.3692 26.9248 43.9572 26.4081C44.5455 25.8912 45.2552 25.531 46.0197 25.3613ZM47.7707 27.3574C47.3421 27.2322 46.8882 27.2176 46.4523 27.3144C46.0166 27.4112 45.6118 27.6164 45.2765 27.9111C44.9414 28.2057 44.6863 28.5803 44.5344 28.9999L44.5334 29.0009L19.9191 96.6796V96.6806C19.7458 97.1552 19.7114 97.6697 19.8205 98.163C19.9296 98.6564 20.1771 99.1085 20.5344 99.4658C20.8916 99.823 21.3438 100.071 21.8371 100.18C22.3304 100.289 22.8449 100.254 23.3195 100.081H23.3205L90.9992 75.4667L91.0002 75.4658L91.1554 75.4042C91.5121 75.2491 91.8313 75.0176 92.089 74.7245C92.3837 74.3896 92.5887 73.9852 92.6857 73.5497C92.7828 73.1144 92.7682 72.6617 92.6437 72.2333C92.5348 71.8585 92.3451 71.5126 92.0881 71.2206L91.9738 71.0995L48.9045 28.0302C48.5892 27.7141 48.1992 27.4825 47.7707 27.3574Z",
			fill: "#14151F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.25 10.25C101.802 10.25 102.25 10.6977 102.25 11.25H101.25C102.217 11.25 102.249 11.2494 102.25 11.25V11.2988C102.25 11.3255 102.249 11.3625 102.247 11.4092C102.244 11.5034 102.238 11.6374 102.226 11.8047C102.202 12.1388 102.154 12.6096 102.061 13.1719C101.874 14.2921 101.499 15.8013 100.738 17.3223C99.9758 18.8471 98.8164 20.4024 97.0586 21.5742C95.2946 22.7502 92.9875 23.5 90 23.5C87.3625 23.5 85.4508 24.1565 84.0508 25.0898C82.6445 26.0274 81.6946 27.2846 81.0508 28.5723C80.4051 29.8637 80.077 31.1671 79.9121 32.1562C79.8301 32.6485 79.7896 33.0569 79.7695 33.3379C79.7595 33.4782 79.7543 33.5866 79.752 33.6572C79.7508 33.692 79.7503 33.7177 79.75 33.7334C79.7499 33.7413 79.75 33.7473 79.75 33.75C79.75 34.3023 79.3023 34.75 78.75 34.75C78.1977 34.75 77.75 34.3023 77.75 33.75H78.75C77.7833 33.75 77.7511 33.7506 77.75 33.75V33.7012C77.7504 33.6745 77.7514 33.6375 77.7529 33.5908C77.7561 33.4966 77.7625 33.3626 77.7744 33.1953C77.7983 32.8612 77.8457 32.3904 77.9395 31.8281C78.1262 30.7079 78.5012 29.1987 79.2617 27.6777C80.0242 26.1529 81.1836 24.5976 82.9414 23.4258C84.7054 22.2498 87.0125 21.5 90 21.5C92.6375 21.5 94.5492 20.8435 95.9492 19.9102C97.3555 18.9726 98.3054 17.7154 98.9492 16.4277C99.5949 15.1363 99.923 13.8329 100.088 12.8438C100.17 12.3515 100.21 11.9431 100.23 11.6621C100.24 11.5218 100.246 11.4134 100.248 11.3428C100.249 11.308 100.25 11.2823 100.25 11.2666V11.248C100.251 10.6967 100.698 10.25 101.25 10.25Z",
			fill: "url(#paint0_linear_7850_501803)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.5 18.75V7.5C66.5 6.94772 66.9477 6.5 67.5 6.5C68.0523 6.5 68.5 6.94772 68.5 7.5V18.75C68.5 19.3023 68.0523 19.75 67.5 19.75C66.9477 19.75 66.5 19.3023 66.5 18.75Z",
			fill: "url(#paint1_linear_7850_501803)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.543 51.793C100.909 51.4269 101.488 51.4043 101.881 51.7246L101.957 51.793L109.457 59.293L109.525 59.3691C109.846 59.7619 109.823 60.3409 109.457 60.707C109.091 61.0731 108.512 61.0957 108.119 60.7754L108.043 60.707L100.543 53.207L100.475 53.1309C100.154 52.7381 100.177 52.1591 100.543 51.793Z",
			fill: "url(#paint2_linear_7850_501803)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.184 32.8018C112.707 32.6271 113.273 32.9098 113.448 33.4336C113.623 33.9574 113.34 34.5235 112.816 34.6982L101.566 38.4482C101.043 38.6229 100.477 38.3402 100.302 37.8164C100.127 37.2926 100.41 36.7265 100.934 36.5518L112.184 32.8018Z",
			fill: "url(#paint3_linear_7850_501803)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.8976 47.1476C36.2637 46.7815 36.8427 46.7589 37.2355 47.0792L37.3117 47.1476L72.8527 82.6886L72.921 82.7638C73.2415 83.1566 73.2188 83.7365 72.8527 84.1027C72.4865 84.4688 71.9066 84.4915 71.5138 84.171L71.4386 84.1027L35.8976 48.5616L35.8292 48.4855C35.5089 48.0927 35.5315 47.5137 35.8976 47.1476Z",
			fill: "#14151F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8977 71.898C27.2638 71.5318 27.8428 71.5092 28.2356 71.8296L28.3118 71.898L48.1028 91.689L48.1712 91.7642C48.4916 92.1569 48.469 92.7369 48.1028 93.103C47.7366 93.4692 47.1567 93.4919 46.7639 93.1714L46.6887 93.103L26.8977 73.312L26.8294 73.2358C26.509 72.8431 26.5316 72.2641 26.8977 71.898Z",
			fill: "#14151F"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_7850_501803",
				x1: 66.5,
				y1: 60.9998,
				x2: 122.742,
				y2: 48.6741,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E45D96"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_7850_501803",
				x1: 66.5,
				y1: 60.9998,
				x2: 122.742,
				y2: 48.6741,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E45D96"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_7850_501803",
				x1: 66.5,
				y1: 60.9998,
				x2: 122.742,
				y2: 48.6741,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E45D96"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_7850_501803",
				x1: 66.5,
				y1: 60.9998,
				x2: 122.742,
				y2: 48.6741,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6A64DE" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E45D96"
				})]
			})
		] })
	]
});
export default SvgConfettiBig;
